'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('#bookPreviewModal').on('shown.bs.modal', function (e) {
        var url = (0, _jquery2.default)('#showBookPreviewLink').attr('data-book-url');
        var code = '<iframe frameborder="0" width="100%" height="100%" src="' + url + '"></iframe>';

        (0, _jquery2.default)('#contentViewer').html(code);
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/bookPreview.js
// module id = 928
// module chunks = 0